import enImg from 'global/images/lngs/en.png';
import frImg from 'global/images/lngs/fr.png';

export const options = [
  { value: 'en', label: 'Eng', icon: enImg },
  { value: 'fr', label: 'Fr', icon: frImg },
];

export default options;
